import React from "react";
import { Entry } from "components/layout/Entry";
import type { Entries } from "sections/Entries/types";

import * as styles from "./MatchPage.module.scss";
import { EntrySkeleton } from "../../../components/layout/Entry/EntrySkeleton";

type MyBetsProps = {
  entries: Entries;
  loading: boolean;
};

const MyBets = ({ entries, loading }: MyBetsProps) => {
  if (loading) {
    return (
      <div className={styles.myBets}>
        <EntrySkeleton />
      </div>
    );
  }

  return (
    <div className={styles.myBets}>
      {entries?.map((entry) => (
        <Entry key={entry.id} entry={entry} isCompact={true} />
      ))}
    </div>
  );
};

export { MyBets };
